<template>
  <div class="tree-warp">
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    <div style="flex: 1; overflow: auto">
      <div class="tree-content">
        <el-tree
          ref="tree"
          :data="data"
          :show-checkbox="checkbox"
          node-key="id"
          :expand-on-click-node="false"
          :highlight-current="true"
          :default-expanded-keys="defaultExpandedKeys"
          :default-expand-all="defaultExpandedAll"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
          :check-strictly="checkStrictly"
          @node-click="bindNodeClick"
          @check="bindCheckChange"
        ></el-tree>
      </div>
    </div>
  </div>
</template>
<script>
import * as utils from "@/utils/index.js";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    defaultExpandedKeys: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultExpandedAll: {
      type: Boolean,
      default: false,
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    defaultCurrent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filterText: "",
    };
  },
  created() {
    if (this.data.length > 0 && this.defaultCurrent == true) {
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.data[0].id);
      });
    }
    console.log(this.defaultExpandedKeys);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    data(val) {
      this.data = val;
      if (val.length > 0 && this.defaultCurrent == true) {
        this.$nextTick(() => {
          console.log(val[0].id);
          this.$refs.tree.setCurrentKey(val[0].id);
        });
      }
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    bindNodeClick(data, node, ev) {
      this.$emit("click", data); //反馈给父组件
    },
    bindCheckChange() {
      let vm = this;
      let data = vm.$refs.tree.getCheckedNodes(false, false);
      let ids = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        ids.push(element.id);
      }
      let selectNodeIdArr = vm.getTreeArrId(data);
      this.$emit("change", selectNodeIdArr, ids); //反馈给父组件
    },
    getTreeArrId(data) {
      let selectNodeIdArr = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        selectNodeIdArr.push({
          id: element.id,
          label: element.label,
        });
      }
      return selectNodeIdArr;
    },
    getCheckedKeys() {
      let data = this.$refs.tree.getCheckedNodes(false, false);
      let selectNodeIdArr = this.getTreeArrId(data);
      return selectNodeIdArr;
    },
    setCancelChecked(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        this.$refs.tree.setChecked(element.id, false, false);
      }
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 1440px) {
  .tree-warp {
    height: 520px;
  }
}
@media screen and (min-width: 1441px) {
  .tree-warp {
    height: 660px;
  }
}
.tree-warp {
}
.el-tree {
  color: #1e1f1f;
  width: 100%;
  height: 100%;
}
.tree-content {
  flex: 1;
  width: 300px;
  display: flex;
}
</style>
